import {defineCustomElement, formatPrice} from 'extensions/utils';
import stylesheet from './x-search-selected-facet.component.scss?as=stylesheet';
import {html, LitElement} from 'lit';

export class SelectedFacet extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			_value: {
				attribute: 'value',
				type: String
			},
			currency: {
				type: Boolean
			},
			label: {
				type: String
			}
		};
	}

	get value () {
		if (this._value.includes(',')) {
			const range = this._value.split(',');

			return range
				.map(l => this.#formatValue(l))
				.join(' - ');
		}

		return this.#formatValue(this._value);
	}

	set value (value) {
		this._value = value;
	}

	constructor () {
		super();

		this.currency = false;
		this._value = '';
	}

	/**
	 * @param {string} value
	 * @returns {string}
	 */
	#formatValue (value) {
		return this.currency
			? formatPrice(value)
			: value;
	}

	render () {
		return html`
			<button aria-value="Remove selected facet ${this.label}: ${this.value}">
				<span class="icon-svg-cancel" aria-hidden="true"></span>
				${this.label}: ${this.value}
			</button>
		`;
	}
};

defineCustomElement('x-search-selected-facet', SelectedFacet);
